export const footerLinks = {
    'lb-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://lb.wingie.com/flights/to-dubai/',
                    title: 'دبي',
                },
                {
                    href: 'https://lb.wingie.com/flights/to-istanbul/',
                    title: 'اسطنبول',
                },
                {
                    href: 'https://lb.wingie.com/flights/to-cairo/',
                    title: 'القاهرة',
                },
                {
                    href: 'https://lb.wingie.com/flights/to-paris/',
                    title: 'باريس',
                },
                {
                    href: 'https://lb.wingie.com/flights/to-london/',
                    title: 'لندن',
                },
                {
                    href: 'https://lb.wingie.com/flights/to-rome/',
                    title: 'روما',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://lb.wingie.com/flights/ae-united-arab-emirates/',
                    title: 'الإمارات العربية المتحدة',
                },
                {
                    href: 'https://lb.wingie.com/flights/tr-turkey/',
                    title: 'تركيا',
                },
                {
                    href: 'https://lb.wingie.com/flights/eg-egypt/',
                    title: 'مصر',
                },
                {
                    href: 'https://lb.wingie.com/flights/fr-france/',
                    title: 'فرنسا',
                },
                {
                    href: 'https://lb.wingie.com/flights/gb-united-kingdom/',
                    title: 'المملكة المتحدة',
                },
                {
                    href: 'https://lb.wingie.com/flights/it-italy/',
                    title: 'إيطاليا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://lb.wingie.com/flights/airlines/middle-east-airlines/',
                    title: 'طيران الشرق الأوسط',
                },
                {
                    href: 'https://lb.wingie.com/flights/airlines/emirates/',
                    title: 'طيران الإمارات',
                },
                {
                    href: 'https://lb.wingie.com/flights/airlines/turkish-airlines/',
                    title: 'الخطوط الجوية التركية',
                },
                {
                    href: 'https://lb.wingie.com/flights/airlines/egyptair/',
                    title: 'مصر للطيران',
                },
                {
                    href: 'https://lb.wingie.com/flights/airlines/air-france/',
                    title: 'إير فرانس',
                },
                {
                    href: 'https://lb.wingie.com/flights/airlines/qatar-airways/',
                    title: 'الخطوط الجوية القطرية',
                },
            ],
        },
    ],
    'lb-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://lb.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/to-paris/',
                    title: 'Paris',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/to-london/',
                    title: 'London',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/to-rome/',
                    title: 'Rome',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://lb.wingie.com/en/flights/ae-united-arab-emirates/',
                    title: 'United Arab Emirates',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/tr-turkey/',
                    title: 'Turkey',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/eg-egypt/',
                    title: 'Egypt',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/gb-united-kingdom/',
                    title: 'United Kingdom',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/it-italy/',
                    title: 'Italy',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://lb.wingie.com/en/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/en/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://lb.wingie.com/ru/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/to-cairo/',
                    title: 'Каир',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/to-paris/',
                    title: 'Париж',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/to-rome/',
                    title: 'Рим',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://lb.wingie.com/ru/flights/ae-united-arab-emirates/',
                    title: 'Объединенные Арабские Эмираты',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/tr-turkey/',
                    title: 'Турция',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/fr-france/',
                    title: 'Франция',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/gb-united-kingdom/',
                    title: 'Великобритания',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/it-italy/',
                    title: 'Италия',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://lb.wingie.com/ru/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/ru/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://lb.wingie.com/es/vuelos/a-dubai/',
                    title: 'Dubái',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/a-estambul/',
                    title: 'Estambul',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/a-el-cairo/',
                    title: 'El Cairo',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/a-paris/',
                    title: 'París',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/a-londres/',
                    title: 'Londres',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/a-roma/',
                    title: 'Roma',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://lb.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
                    title: 'Emiratos Árabes Unidos',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/tr-turquia/',
                    title: 'Turquía',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/eg-egipto/',
                    title: 'Egipto',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/fr-francia/',
                    title: 'Francia',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/gb-reino-unido/',
                    title: 'Reino Unido',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/it-italia/',
                    title: 'Italia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://lb.wingie.com/es/vuelos/companias-aereas/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/companias-aereas/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/companias-aereas/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/companias-aereas/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/companias-aereas/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/es/vuelos/companias-aereas/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://lb.wingie.com/de/flug/nach-beirut/',
                    title: 'Beirut',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/nach-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/nach-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/nach-kairo/',
                    title: 'Kairo',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/nach-paris/',
                    title: 'Paris',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/nach-london/',
                    title: 'London',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://lb.wingie.com/de/flug/tr-turkei/',
                    title: 'Türkei',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/ae-vereinigte-arabische-emirate/',
                    title: 'Vereinigte Arabische Emirate',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/eg-agypten/',
                    title: 'Ägypten',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/fr-frankreich/',
                    title: 'Frankreich',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/gb-grossbritannien/',
                    title: 'Großbritannien',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/cy-zypern/',
                    title: 'Zypern',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://lb.wingie.com/de/flug/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/airlines/egyptair/',
                    title: 'EgyptAir',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/de/flug/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-it': [
        {
            title: 'Destinazioni Top',
            items: [
                {
                    href: 'https://lb.wingie.com/it/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/to-cairo/',
                    title: 'Il Cairo',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/to-paris/',
                    title: 'Parigi',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/to-london/',
                    title: 'Londra',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/to-rome/',
                    title: 'Roma',
                },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                {
                    href: 'https://lb.wingie.com/it/flights/ae-united-arab-emirates/',
                    title: 'Emirati Arabi Uniti',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/tr-turkey/',
                    title: 'Turchia',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/eg-egypt/',
                    title: 'Egitto',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/fr-france/',
                    title: 'Francia',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/gb-united-kingdom/',
                    title: 'Regno Unito',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/it-italy/',
                    title: 'Italia',
                },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                {
                    href: 'https://lb.wingie.com/it/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/it/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-fr': [
        {
            title: 'Meilleures Destinations',
            items: [
                {
                    href: 'https://lb.wingie.com/fr/flights/to-dubai/',
                    title: 'Dubaï',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/to-cairo/',
                    title: 'Le Caire',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/to-paris/',
                    title: 'Paris',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/to-london/',
                    title: 'Londres',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/to-rome/',
                    title: 'Rome',
                },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                {
                    href: 'https://lb.wingie.com/fr/flights/ae-united-arab-emirates/',
                    title: 'Émirats Arabes Unis',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/tr-turkey/',
                    title: 'Turquie',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/eg-egypt/',
                    title: 'Égypte',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/gb-united-kingdom/',
                    title: 'Royaume-Uni',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/it-italy/',
                    title: 'Italie',
                },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                {
                    href: 'https://lb.wingie.com/fr/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/fr/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-pt': [
        {
            title: 'Principais Destinos',
            items: [
                {
                    href: 'https://lb.wingie.com/pt/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/to-istanbul/',
                    title: 'Istambul',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/to-paris/',
                    title: 'Paris',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/to-london/',
                    title: 'Londres',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/to-rome/',
                    title: 'Roma',
                },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                {
                    href: 'https://lb.wingie.com/pt/flights/ae-united-arab-emirates/',
                    title: 'Emirados Árabes Unidos',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/tr-turkey/',
                    title: 'Turquia',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/eg-egypt/',
                    title: 'Egito',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/fr-france/',
                    title: 'França',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/gb-united-kingdom/',
                    title: 'Reino Unido',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/it-italy/',
                    title: 'Itália',
                },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                {
                    href: 'https://lb.wingie.com/pt/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/pt/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-ro': [
        {
            title: 'Destinații de Top',
            items: [
                {
                    href: 'https://lb.wingie.com/ro/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/to-paris/',
                    title: 'Paris',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/to-london/',
                    title: 'Londra',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/to-rome/',
                    title: 'Roma',
                },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                {
                    href: 'https://lb.wingie.com/ro/flights/ae-united-arab-emirates/',
                    title: 'Emiratele Arabe Unite',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/tr-turkey/',
                    title: 'Turcia',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/eg-egypt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/fr-france/',
                    title: 'Franța',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/gb-united-kingdom/',
                    title: 'Regatul Unit',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/it-italy/',
                    title: 'Italia',
                },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                {
                    href: 'https://lb.wingie.com/ro/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/ro/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-pl': [
        {
            title: 'Najlepsze Destynacje',
            items: [
                {
                    href: 'https://lb.wingie.com/pl/flights/to-dubai/',
                    title: 'Dubaj',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/to-istanbul/',
                    title: 'Stambuł',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/to-cairo/',
                    title: 'Kair',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/to-paris/',
                    title: 'Paryż',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/to-london/',
                    title: 'Londyn',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/to-rome/',
                    title: 'Rzym',
                },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                {
                    href: 'https://lb.wingie.com/pl/flights/ae-united-arab-emirates/',
                    title: 'Zjednoczone Emiraty Arabskie',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/tr-turkey/',
                    title: 'Turcja',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/eg-egypt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/fr-france/',
                    title: 'Francja',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/gb-united-kingdom/',
                    title: 'Wielka Brytania',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/it-italy/',
                    title: 'Włochy',
                },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                {
                    href: 'https://lb.wingie.com/pl/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/pl/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-lt': [
        {
            title: 'Populiariausi Miestai',
            items: [
                {
                    href: 'https://lb.wingie.com/lt/flights/to-dubai/',
                    title: 'Dubajus',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/to-istanbul/',
                    title: 'Stambulas',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/to-cairo/',
                    title: 'Kairas',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/to-paris/',
                    title: 'Paryžius',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/to-london/',
                    title: 'Londonas',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/to-rome/',
                    title: 'Roma',
                },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                {
                    href: 'https://lb.wingie.com/lt/flights/ae-united-arab-emirates/',
                    title: 'Jungtiniai Arabų Emyratai',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/tr-turkey/',
                    title: 'Turkija',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/eg-egypt/',
                    title: 'Egiptas',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/fr-france/',
                    title: 'Prancūzija',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/gb-united-kingdom/',
                    title: 'Jungtinė Karalystė',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/it-italy/',
                    title: 'Italija',
                },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                {
                    href: 'https://lb.wingie.com/lt/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/lt/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-uz': [
        {
            title: 'Eng Mashhur Shaharlar',
            items: [
                {
                    href: 'https://lb.wingie.com/uz/flights/to-dubai/',
                    title: 'Dubay',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/to-cairo/',
                    title: 'Qohira',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/to-paris/',
                    title: 'Parij',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/to-london/',
                    title: 'London',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/to-rome/',
                    title: 'Rim',
                },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                {
                    href: 'https://lb.wingie.com/uz/flights/ae-united-arab-emirates/',
                    title: 'Birlashgan Arab Amirliklari',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/tr-turkey/',
                    title: 'Turkiya',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/eg-egypt/',
                    title: 'Misr',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/fr-france/',
                    title: 'Fransiya',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/gb-united-kingdom/',
                    title: 'Buyuk Britaniya',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/it-italy/',
                    title: 'Italiya',
                },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                {
                    href: 'https://lb.wingie.com/uz/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/uz/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-sr': [
        {
            title: 'Најпопуларније дестинације',
            items: [
                {
                    href: 'https://lb.wingie.com/sr/flights/to-dubai/',
                    title: 'Дубаи',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/to-istanbul/',
                    title: 'Истанбул',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/to-cairo/',
                    title: 'Каиро',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/to-paris/',
                    title: 'Париз',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/to-rome/',
                    title: 'Рим',
                },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                {
                    href: 'https://lb.wingie.com/sr/flights/ae-united-arab-emirates/',
                    title: 'Уједињени Арапски Емирати',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/tr-turkey/',
                    title: 'Турска',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/eg-egypt/',
                    title: 'Египат',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/fr-france/',
                    title: 'Француска',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/gb-united-kingdom/',
                    title: 'Уједињено Краљевство',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/it-italy/',
                    title: 'Италија',
                },
            ],
        },
        {
            title: 'Популарне авиокомпаније',
            items: [
                {
                    href: 'https://lb.wingie.com/sr/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/sr/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-ky': [
        {
            title: 'Эң популярдуу шаарлар',
            items: [
                {
                    href: 'https://lb.wingie.com/ky/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/to-cairo/',
                    title: 'Каир',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/to-paris/',
                    title: 'Париж',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/to-rome/',
                    title: 'Рим',
                },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                {
                    href: 'https://lb.wingie.com/ky/flights/ae-united-arab-emirates/',
                    title: 'Бириккен Араб Эмираттары',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/tr-turkey/',
                    title: 'Түркия',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/fr-france/',
                    title: 'Франция',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/gb-united-kingdom/',
                    title: 'Улуу Британия',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/it-italy/',
                    title: 'Италия',
                },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                {
                    href: 'https://lb.wingie.com/ky/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/ky/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-tg': [
        {
            title: 'Шаҳрҳои машҳур',
            items: [
                {
                    href: 'https://lb.wingie.com/tg/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/to-istanbul/',
                    title: 'Истанбул',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/to-cairo/',
                    title: 'Қоҳира',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/to-paris/',
                    title: 'Париж',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/to-rome/',
                    title: 'Рим',
                },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                {
                    href: 'https://lb.wingie.com/tg/flights/ae-united-arab-emirates/',
                    title: 'Иморотҳои Муттаҳидаи Араб',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/tr-turkey/',
                    title: 'Туркия',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/eg-egypt/',
                    title: 'Миср',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/fr-france/',
                    title: 'Фаронса',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/gb-united-kingdom/',
                    title: 'Подшоҳии Муттаҳида',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/it-italy/',
                    title: 'Италия',
                },
            ],
        },
        {
            title: 'Ширкатҳои машҳури авиатсионӣ',
            items: [
                {
                    href: 'https://lb.wingie.com/tg/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/tg/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-kk': [
        {
            title: 'Танымал бағыттар',
            items: [
                {
                    href: 'https://lb.wingie.com/kk/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/to-cairo/',
                    title: 'Каир',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/to-paris/',
                    title: 'Париж',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/to-rome/',
                    title: 'Рим',
                },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                {
                    href: 'https://lb.wingie.com/kk/flights/ae-united-arab-emirates/',
                    title: 'Біріккен Араб Әмірліктері',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/tr-turkey/',
                    title: 'Түркия',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/fr-france/',
                    title: 'Франция',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/gb-united-kingdom/',
                    title: 'Ұлыбритания',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/it-italy/',
                    title: 'Италия',
                },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                {
                    href: 'https://lb.wingie.com/kk/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/kk/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-nl': [
        {
            title: 'Top Bestemmingen',
            items: [
                {
                    href: 'https://lb.wingie.com/nl/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/to-cairo/',
                    title: 'Caïro',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/to-paris/',
                    title: 'Parijs',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/to-london/',
                    title: 'Londen',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/to-rome/',
                    title: 'Rome',
                },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                {
                    href: 'https://lb.wingie.com/nl/flights/ae-united-arab-emirates/',
                    title: 'Verenigde Arabische Emiraten',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/tr-turkey/',
                    title: 'Turkije',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/eg-egypt/',
                    title: 'Egypte',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/fr-france/',
                    title: 'Frankrijk',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/gb-united-kingdom/',
                    title: 'Verenigd Koninkrijk',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/it-italy/',
                    title: 'Italië',
                },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                {
                    href: 'https://lb.wingie.com/nl/flights/airlines/middle-east-airlines/',
                    title: 'Middle East Airlines',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/airlines/air-france/',
                    title: 'Air France',
                },
                {
                    href: 'https://lb.wingie.com/nl/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
            ],
        },
    ],
    'lb-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://lb.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://lb.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://lb.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://lb.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://lb.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://lb.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://lb.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://lb.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://lb.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://lb.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://lb.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://lb.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://lb.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://lb.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://lb.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://lb.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://lb.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'lb-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://lb.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://lb.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://lb.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://lb.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://lb.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://lb.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://lb.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://lb.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://lb.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://lb.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://lb.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://lb.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://lb.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://lb.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://lb.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://lb.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://lb.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'lb-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://lb.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://lb.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://lb.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://lb.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://lb.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://lb.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://lb.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://lb.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://lb.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://lb.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://lb.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://lb.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://lb.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://lb.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://lb.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://lb.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://lb.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'lb-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://lb.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://lb.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://lb.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://lb.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://lb.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://lb.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://lb.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://lb.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://lb.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://lb.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://lb.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://lb.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://lb.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://lb.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://lb.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://lb.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://lb.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'lb-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://lb.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://lb.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://lb.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://lb.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://lb.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://lb.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://lb.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://lb.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://lb.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://lb.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://lb.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://lb.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://lb.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://lb.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://lb.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://lb.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://lb.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'lb-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://lb.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://lb.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://lb.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://lb.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://lb.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://lb.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://lb.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://lb.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://lb.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://lb.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://lb.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://lb.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://lb.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://lb.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://lb.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://lb.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://lb.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'lb-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://lb.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://lb.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://lb.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://lb.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://lb.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://lb.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://lb.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://lb.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://lb.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://lb.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://lb.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://lb.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://lb.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://lb.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://lb.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://lb.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://lb.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'lb-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://lb.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://lb.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://lb.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://lb.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://lb.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://lb.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://lb.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://lb.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://lb.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://lb.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://lb.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://lb.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://lb.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://lb.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://lb.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://lb.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://lb.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://lb.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}